/**************************************************
 * Nombre:       Formulario_Cuenta
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, BadgeOutlined, DiamondOutlined, Flag} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {PAISESINDICATIVO} from "../../Modulo_formularios/Recursos/indicativos";
import {ESTADOSCUENTA} from "../../Constantes";

const Formulario_Cuenta = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOSCUENTA.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'} dato={'nombres'} {...props}
                                  requerido={'El Nombres es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props}
                                  requerido={'El Apellido es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoSelect Icono={BadgeOutlined} nombre={'Pais'} dato={'pais'} {...props}
                                   opciones={PAISESINDICATIVO.map((it) => it.nameES)}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Celular'} dato={'celular'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={DiamondOutlined} nombre={'Dimante Superior'} dato={'diamante'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Cuenta